import classNames from "classnames";
import { TypographyProps } from "./types";

export const Typography = ({
  children,
  tag,
  className,
  focusable = false,
  onKeyDown,
  ...props
}: TypographyProps): JSX.Element => {
  const Tag = tag;

  return (
    <Tag 
      className={classNames(
        className,
        focusable && "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      )}
      tabIndex={focusable ? 0 : undefined}
      onKeyDown={onKeyDown}
      {...props}
    >
      {children}
    </Tag>
  );
};
